import React from 'react';
import HeaderFull from '@ecs/tng-common/components/header/HeaderFull';
// Styles
import '@ecs/tng-common/styles/bootstrap-no-purge.scss';
import '../styles/global/full-layout.scss';
import '../styles/global/index.scss';

interface LayoutProps {
  children: React.ReactNode;
}

class LayoutArticles extends React.PureComponent<LayoutProps> {
  render() {
    return (
      <>
        <HeaderFull pageType="blog" />
        {this.props.children}
      </>
    );
  }
}

export default LayoutArticles;
